/* eslint-disable max-classes-per-file */
import { Modal, ModalController } from '~/scripts/services/modal/modal';
import widgetSettings from './widget-settings.html';
import './widget-settings.scss';

class Controller extends ModalController {
	/** @type {Dashboard.BaseWidget} */
	widget;

	/** @type {boolean} */
	isLoading

	/**
	 *
	 * @param {Dashboard.BaseWidget} options
	 * @param options
	 * @param {angular.ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param $injector
	 */
	/* @ngInject */
	constructor(options, $uibModalInstance, $injector) {
		super(options, $uibModalInstance, $injector);

		this.isLoading = true;
		this.isValid = false;
		this.widgetData = {};

		this.widget = this.options;

		this.$rootScope = this.$injector.get('$rootScope');
		this.$compile = this.$injector.get('$compile');

		this.$uibModalInstance.rendered
			.then(() => {
				const settings = this.createSettings();
				this.isLoading = false;
				return settings;
			})
			.catch(console.error);
	}

	onSave() {
		this.actions.close(this.widgetData);
	}

	// eslint-disable-next-line class-methods-use-this
	createBaseWidgetSettings(name, data) {
		const scope = this.$rootScope.$new(true);

		// @ts-ignore
		scope.$ctrl = data;

		const compiled = this.$compile(name)(scope);
		const element = compiled.get(0);

		const holder = document.querySelector('.widget-settings .slot');
		holder.append(element);
	}

	createKTableWidgetSettings() {
		this.createBaseWidgetSettings(
			'<ktable-settings class="settings" widget="$ctrl.widget" parent="$ctrl.parent"></ktable-settings>',
			{
				widget: this.widget,
				parent: this,
			},
		);
	}

	createPieChartWidgetSettings() {
		this.createBaseWidgetSettings(
			'<pie-chart-settings class="settings" widget="$ctrl.widget" parent="$ctrl.parent"></pie-chart-settings>',
			{
				widget: this.widget,
				parent: this,
			},
		);
	}

	createGaugeChartWidgetSettings() {
		this.createBaseWidgetSettings(
			'<gauge-chart-settings class="settings" widget="$ctrl.widget" parent="$ctrl.parent"></gauge-chart-settings>',
			{
				widget: this.widget,
				parent: this,
			},
		);
	}

	/**
	 * @type {Dashboard.Widget.createSettingsFn}
	 */
	createSettings() {
		const { type } = this.widget;

		/** @type {Dashboard.Widget.WidgetSettingsBuilderObj} */
		const widgets = {
			ktable: () => this.createKTableWidgetSettings(),
			'pie-chart': () => this.createPieChartWidgetSettings(),
			'gauge-chart': () => this.createGaugeChartWidgetSettings(),
			// @ts-ignore
			default: () => {
				console.error('Invalid widget type');
			},
		};

		const widgetBuilder = type in widgets ? widgets[type] : widgets.default;

		return widgetBuilder();
	}
}

class WidgetSettingsModal extends Modal {
	open(widget) {
		return super.open({
			template: widgetSettings,
			controller: Controller,
			windowTopClass: 'widget-settings',
		}, widget);
	}
}

export { WidgetSettingsModal };
